import {JSONModel} from "../json.model";

export class AppSettingsModel extends JSONModel {
  [key: string]: any;

  constructor(data?: any) {
    data = data || {};
    super({});

    if (data && typeof data === "object") {
      for (const key of Object.keys(data)) {
        this[key] = data[key];
      }
    }
  }
}
